import { useSearchParams, Link } from 'react-router-dom';
import { resolveSsoErrorCopy } from './ssoErrorCopy.js';
import styles from './SsoErrorPage.module.css';

/**
 * `/sso-error` is where `api/controllers/ssoController.js` sends a visitor when single sign-on
 * fails. Each of the six reason codes it can emit gets its own sentence and its own next step;
 * anything else (including a missing reason) renders one safe generic message.
 *
 * ⛔ The raw `?reason=` value is NEVER printed. Only a code that matched the fixed vocabulary in
 * `ssoErrorCopy.js` is echoed back, as a short trace reference for support.
 */
const SsoErrorPage = () => {
  const [searchParams] = useSearchParams();
  const { message, nextStep, known } = resolveSsoErrorCopy(searchParams.get('reason'));

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.iconWrapper}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
          </svg>
        </div>
        <h1 className={styles.title}>SSO Login Failed</h1>
        <p className={styles.message}>{message}</p>
        <div className={styles.nextStep}>
          <span className={styles.nextStepLabel}>What to do next</span>
          <p className={styles.nextStepText}>{nextStep}</p>
        </div>
        {known && <p className={styles.code}>Error: {known}</p>}
        <Link to="/login" className={styles.loginLink}>
          Go to Login
        </Link>
      </div>
    </div>
  );
};

export default SsoErrorPage;
